import DigitalSignature from './DigitalSignature/DigitalSignature';

const TabTerm = ({
  values,
  printCompany,
  localSignatureData,
  setLocalSignatureData,
  isSignatureReset,
  setIsSignatureReset,
}) => {
  return (
    <div style={{ marginTop: 20 }}>
      <h5
        style={{
          color: 'white',
          fontFamily: 'Poppins, sans-serif',
          marginBottom: '15px',
        }}
      >
        Termo de autorização
      </h5>
      <div style={{ width: '100%' }}>
        <textarea
          disabled
          value={
            values?.authorizationTerm || printCompany?.authorizationTerm || ''
          }
          style={{
            width: '100%',
            minHeight: '400px',
            padding: '10px',
            backgroundColor: '#2a2a2a',
            color: 'white',
            border: '1px solid #444',
            borderRadius: '4px',
            fontFamily: 'Poppins, sans-serif',
            fontSize: '14px',
            resize: 'vertical',
          }}
        />
      </div>

      {/* Assinatura Digital */}
      <DigitalSignature
        values={values}
        localSignatureData={localSignatureData}
        setLocalSignatureData={setLocalSignatureData}
        isSignatureReset={isSignatureReset}
        setIsSignatureReset={setIsSignatureReset}
      />
    </div>
  );
};

export default TabTerm;
